import React from 'react';
import PropTypes from 'prop-types';
import ClipLoader from 'react-spinners/ClipLoader';

import '../styles/materialsearch.scss';

const MaterialSearch = ({
  clearLeft,
  loading,
  maxResults,
  onClear,
  results,
  showResults,
  style,
  value,
  ...rest
}) => {
  const buildResultText = () => {
    if (results === maxResults) {
      return `${results.toLocaleString('en-US')}+ results`;
    }

    return `${results.toLocaleString('en-US')} result${results !== 1 ? 's' : ''}`;
  };

  const renderSearchIcon = () => {
    if (loading) {
      return <ClipLoader size={15} color="#2196F3" />;
    }

    if (clearLeft && value !== '') {
      return (
        <div className="search-icon clear" onClick={onClear}>
          <i className="fal fa-times fa-fw" />
        </div>
      );
    }

    return <i className="fas fa-search fa-fw" />;
  };

  return (
    <div className="material-search-wrapper" style={style}>
      <div className="search-icon">{renderSearchIcon()}</div>
      <div className="search-input">
        <input className="form-control" type="Text" value={value} {...rest} />
      </div>
      {onClear && value !== '' && clearLeft !== true && (
        <div className="search-icon clear" title="Clear" onClick={onClear}>
          <i className="fal fa-times fa-fw" />
        </div>
      )}
      {showResults && <div className="search-results">{buildResultText()}</div>}
    </div>
  );
};

MaterialSearch.defaultProps = {
  onBlur: () => {},
  onChange: () => {},
  onFocus: () => {},
  loading: false,
  maxResults: 10000,
  placeholder: 'Search',
  results: 0,
  showResults: true,
  style: {},
  value: '',
};

MaterialSearch.propTypes = {
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  onFocus: PropTypes.func,
  loading: PropTypes.bool,
  maxResults: PropTypes.number,
  placeholder: PropTypes.string,
  results: PropTypes.number,
  showResults: PropTypes.bool,
  style: PropTypes.object,
  value: PropTypes.string,
};

export default MaterialSearch;
